import ApiBase from "Services/Api/ApiBase";

export default new class extends ApiBase {
    route = '/service-users/:service_user/mars-information';
};
